module.exports = __webpack_public_path__ + "69b9a9751ad3f942b3254a29a9c5d5be.svg";